import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/step_thumb.png"

export function Index() {
  return (
    <Layout
      title="STEP Conference: UAE Startup Photo Success Story"
      description="STEP Conference Dubai enhanced with Premagic AI. Middle East's premier startup event boosted networking with smart photos."
      metaImage={ThumbnailImage}
      keywords={[
        "STEP Conference, Dubai startups, UAE startup events, Middle East entrepreneurship, Dubai startup ecosystem, startup photo sharing, entrepreneur networking UAE, MENA startup conferences, Dubai tech startups, startup community Dubai, UAE innovation events",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "STEP Conference", url: "/case-study/step-conference/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "STEP Conference: UAE Startup Photo Success Story",
            "description": "STEP Conference Dubai enhanced with Premagic AI. Middle East's premier startup event boosted networking with smart photos.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.STEPCONFERENCE} />
    </Layout>
  )
}

export default Index
